import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Controller: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-195c-19.56 0-36.24-12.54-42.43-30h-122.57v30h-105c-41.36 0-75-33.64-75-75v-130h15c8.27 0 15-6.73 15-15v-95c0-8.27-6.73-15-15-15h-15v-210h150v-30h135c19.56 0 36.24 12.54 42.43 30h137.57c41.36 0 75 33.64 75 75zm-390-60h180v15c0 8.27 6.73 15 15 15h165v-435c0-24.81-20.19-45-45-45h-165v-15c0-8.27-6.73-15-15-15h-105v30h-150v152.57c17.46 6.19 30 22.87 30 42.43v95c0 19.56-12.54 36.24-30 42.43v102.57c0 24.81 20.19 45 45 45h75z' />
    <path d='m577.24 647.89-59.28-95.76c-5.28-8.54-7.96-17.58-7.96-26.87v-272.56c0-7.39 1.72-14.69 5.11-21.69l52.11-107.55 27 13.08-52.11 107.55c-1.4 2.89-2.11 5.78-2.11 8.61v272.57c0 3.63 1.17 7.36 3.47 11.08l59.28 95.76-25.51 15.79z' />
  </IconBase>
));

Controller.displayName = 'Controller';

export default Controller;
